import {
    REQUEST_UPDATE_PAYMENT_TYPE, REQUEST_UPDATE_PAYMENT_TYPE_FAILURE,
    REQUEST_UPDATE_PAYMENT_TYPE_SUCCESS
} from "../../../constant/master/TransPaymentTypeConstant";


const initialState = {
    updatePaymentType: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updatePaymentTypeReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_PAYMENT_TYPE:
            return {
                ...state,
                updatePaymentType: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_PAYMENT_TYPE_SUCCESS:
            return {
                ...state,
                updatePaymentType: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_PAYMENT_TYPE_FAILURE:
            return {
                ...state,
                updatePaymentType: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
